<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QiYxq4/tc-custom/9798889104995.jpg?1720272535984" alt="This image is the cover for the book The Chaplin River Letters"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Chaplin River Letters
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:16px;font-family:"Times New Roman",serif;'>In this gripping account, M. L. Jordan unveils the raw truths of the Civil War era. Beyond polished tales, dive into a world filled with desire, mystery, and chaos. Personal letters shed light on passionate love, deep betrayals, and unwavering faith. Experience America’s pivotal moment through the eyes of those on the battlegrounds and in whispered secrets. This isn't just history: it’s the heart and soul of a nation at war.</span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        M. L. Jordan
      </h2>
      
      <p class="authorDescription body article"><p class="Standard" style='margin:0in;font-size:15px;font-family:"Times New Roman",serif;text-align:justify;'>M. L. Jordan briefly lived on a farm in Perryville, Kentucky close to the Perryville Battlefield. She holds a BA in religious studies from Centre College and is also a graduate of Midway College of Nursing. She was an RN for many years working mainly in the emergency room and as a hospice nurse. She and her husband live on the coast in South Carolina.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a1f5bb06